<app-header></app-header>

<div class="p-4">

  <!-- En-tête -->
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Offres de recrutement</h2>
      <p class="text-xs text-gray-400 m-0">Création et publication des offres d'emploi de l'établissement</p>
    </div>
  </div>

  <!-- Carte tableau -->
  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">

    <!-- Barre d'outils -->
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      @if (buttonsPermission?.add) {
        <button (click)="add(formContent)"
                class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold transition-colors">
          + Nouvelle offre
        </button>
      }
      @if (selected_data && buttonsPermission?.edit) {
        <button (click)="edit(formContent)"
                class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm transition-colors">
          Modifier
        </button>
      }
      @if (buttonsPermission?.status) {
        <button (click)="setState(1)"
                class="px-3 py-1.5 rounded-lg border border-green-300 text-green-700 hover:bg-green-50 text-sm transition-colors">
          Publier
        </button>
        <button (click)="setState(2)"
                class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm transition-colors">
          Clôturer
        </button>
      }
      @if (selected_data && buttonsPermission?.delete) {
        <button (click)="delete()"
                class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">
          Supprimer
        </button>
      }
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher..."
               class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-56">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <!-- Tableau -->
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2 w-8"></th>
            <th class="px-3 py-2">Titre</th>
            <th class="px-3 py-2">Catégorie</th>
            <th class="px-3 py-2">Contrat</th>
            <th class="px-3 py-2 text-center">Postes</th>
            <th class="px-3 py-2">Date limite</th>
            <th class="px-3 py-2 text-center">Statut</th>
            <th class="px-3 py-2 text-center">Candidatures</th>
            <th class="px-3 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (d of data | sampleSearch:search_text:'title' | paginate:{id:'offerPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30 transition-colors">
              <td class="px-3 py-2"><input type="radio" [checked]="selected_data?.id === d.id" name="offerRadio" (click)="checked(d)" class="accent-ag-red"></td>
              <td class="px-3 py-2 font-semibold text-gray-800">{{d.title}}</td>
              <td class="px-3 py-2">
                @if (d.category) { <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs">{{d.category}}</span> }
                @else { <span class="text-gray-300">—</span> }
              </td>
              <td class="px-3 py-2 text-gray-600">{{d.contract_type || '—'}}</td>
              <td class="px-3 py-2 text-center text-gray-600">{{d.positions || 1}}</td>
              <td class="px-3 py-2 text-gray-500">{{d.deadline ? (d.deadline | date:'dd/MM/yyyy') : '—'}}</td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="statusClass(d.status)">{{statusLabel(d.status)}}</span>
              </td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 text-xs font-semibold">{{d.applications_count ?? 0}}</span>
              </td>
              <td class="px-3 py-2 text-center">
                <button (click)="showApplications(d, applicationsContent)"
                        class="px-2.5 py-1 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-xs transition-colors">
                  Voir candidatures
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (!loading && data.length === 0) {
      <p class="text-center text-gray-400 py-8 text-sm">Aucune offre enregistrée.</p>
    }

    <div class="flex justify-center py-3">
      <pagination-controls id="offerPg" (pageChange)="getPage($event)"
                           [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true">
      </pagination-controls>
    </div>
  </div>
</div>

<!-- Modal formulaire -->
<ng-template #formContent let-c="close" let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">{{form.id ? 'Modifier' : 'Nouvelle'}} offre</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <form #f="ngForm" (ngSubmit)="form.id ? update(form) : store(form)">
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Titre du poste *</label>
        <input name="title" [(ngModel)]="form.title" required placeholder="Ex: Enseignant de Mathématiques"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Catégorie</label>
        <input name="category" [(ngModel)]="form.category" placeholder="Ex: Enseignement, Administration..."
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Type de contrat *</label>
        <select name="contract_type" [(ngModel)]="form.contract_type" required class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          @for (c of CONTRACT_TYPES; track c) { <option [value]="c">{{c}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Lieu</label>
        <input name="location" [(ngModel)]="form.location" placeholder="Ex: Cotonou"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Nombre de postes</label>
        <input name="positions" type="number" min="1" [(ngModel)]="form.positions"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Salaire min (FCFA)</label>
        <input name="salary_min" type="number" min="0" [(ngModel)]="form.salary_min"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Salaire max (FCFA)</label>
        <input name="salary_max" type="number" min="0" [(ngModel)]="form.salary_max"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Date limite *</label>
        <input name="deadline" type="date" [(ngModel)]="form.deadline" required
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Description *</label>
        <textarea name="description" rows="3" [(ngModel)]="form.description" required
                  class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10"></textarea>
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Profil recherché</label>
        <textarea name="profile_required" rows="3" [(ngModel)]="form.profile_required"
                  class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10"></textarea>
      </div>
    </div>
    <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Annuler</button>
      <button type="submit" [disabled]="f.invalid || loading"
              class="px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">
        Enregistrer <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>

<!-- Modal candidatures -->
<ng-template #applicationsContent let-c="close" let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">Candidatures — {{currentOffer?.title}}</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <div class="p-5">
    <app-loading [isVisible]="applicationsLoading"></app-loading>
    @if (!applicationsLoading && applications.length === 0) {
      <p class="text-center text-gray-400 py-8 text-sm">Aucune candidature pour cette offre.</p>
    }
    @if (applications.length > 0) {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
              <th class="px-3 py-2">Candidat</th>
              <th class="px-3 py-2">Email</th>
              <th class="px-3 py-2">Téléphone</th>
              <th class="px-3 py-2 text-center">Expérience</th>
              <th class="px-3 py-2 text-center">Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (a of applications; track a.id) {
              <tr class="border-t border-gray-50">
                <td class="px-3 py-2 font-semibold text-gray-800">{{a.firstname}} {{a.lastname}}</td>
                <td class="px-3 py-2 text-gray-600">{{a.email}}</td>
                <td class="px-3 py-2 text-gray-600">{{a.phone || '—'}}</td>
                <td class="px-3 py-2 text-center text-gray-600">{{a.years_experience ?? 0}} an(s)</td>
                <td class="px-3 py-2 text-center">
                  <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="appStatusClass(a.status)">{{appStatusLabel(a.status)}}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <p class="text-xs text-gray-400 mt-3">Pour gérer le workflow (présélection, entretien, embauche), utilisez la page « Workflow de recrutement ».</p>
    }
  </div>
  <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
    <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Fermer</button>
  </div>
</ng-template>
